/* eslint-disable prettier/prettier */
import Component from "../abstracts/Component";
import { doAjax } from "../utils/ajaxUtil";
import TrackingComponent from "../components/TrackingComponent";
import { isMobile, MobileBreakpoint } from "../utils/MobileUtils";
import FixBody from "../utils/FixBody";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";

export default class AddToCartComponent extends Component {
  get SELECTORS() {
    return {
      main: ".js-addtocart",
      error: ".js-addtocart-notification",
      container: ".js-form-container",
      sizeSelect: ".sizes-select",
      sizeSelectModal: ".sizes-select-modal",
      queryId: '[data-algolia-query-id]',
      authenticatedUserToken: '[data-authenticated-user-token]',
      searchIndex: '[data-search-index]',
    };
  }

  get CLASSES() {
    return {
      addingClass: "button--loading",
      addedClass: "added",
    };
  }

  constructor(compEl) {
    super(compEl);
    // this.timeout = null;
    this.mainTargets = document.querySelectorAll(this.SELECTORS.main);
    // externals
    this.TrackingComponent = new TrackingComponent();
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
    this.a11yMessages = {
      cart: {
        added: this.$component.dataset.labelCartAdded || "",
        error: this.$component.dataset.labelCartAddError || "",
      },
    };
  }

  // return the size selected given the add to cart button
  selectedSize(target) {
    //
    let sizeSelected;
    let sizes = $(
      '[data-sizes-code="prod_' + target.dataset.productCode + '"]',
    );
    // console.log(sizeSelected);

    // if i have sizes
    if (sizes != null && sizes.length > 0) {
      // if is selected
      let selectedBox, selectedSection, customSelect;
      if (sizes.length > 1 || $("body").hasClass("t-lookbook")) {
        selectedSection = $(target).parentsUntil(".bar-container");
        selectedBox = selectedSection.find(".select2-selection");
        customSelect = $(
          ".sizes-select-modal",
          $(target).parentsUntil(".product-card__info-container")[
            $(target).parentsUntil(".product-card__info-container").length - 1
          ],
        );
      } else {
        customSelect = $(".sizes-select");
        selectedBox = sizes.find(".select2-selection");
      }
      if (selectedBox !== null) {
        let selectedOption =
          customSelect.select2("data") &&
          customSelect.select2("data").length &&
          customSelect.select2("data")[0].id;
        if (selectedOption !== null) {
          sizeSelected = selectedOption;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      // uniquesize should be
      sizeSelected = target.dataset.code;
    }
    return sizeSelected;
  }

  bindEvents() {
    // global
    let ctx = this;
    // click on addtocart button
    if (this.mainTargets != null) {
      this.mainTargets.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          // prevent default action
          e.preventDefault();
          // btn to target , take care i click on the span
          let btn =
            e.target.localName == "span" ? e.target.parentNode : e.target;
          // get size code
          let sizeCode = ctx.selectedSize(btn);
          ctx.log(" sizeCode ", sizeCode);
          // check if is size selected
          if (
            typeof sizeCode == "undefined" ||
            sizeCode == null ||
            sizeCode == ""
          ) {
            ctx.log("Select a size");
            // emit size required event
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, btn);
            // add here open select2
            $(".sizes-select").select2("open");
          } else {
            // let's trigger the event to add to cart
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtocart, {
              button: btn,
              sizeCode: sizeCode,
            });
            // track event
            const productCode = btn.dataset.productCode;
            ctx.TrackingComponent.actions.addToCart(productCode);
          }
        });
      });
    }

    // Add To Cart Event
    this.$on(
      this.$customEvents.PRODUCT_EVENTS.addtocart,
      ({ event, payload }) => {
        // vars
        let elem = payload.button;
        // set the size code into the button
        elem.setAttribute("data-code", payload.sizeCode);
        // loader
        this.$emit(this.$customEvents.LOADER_EVENTS.showLocal, {
          button: elem,
        });
        // hide error

        elem.disabled = true;
        const queryId = document.querySelector(this.SELECTORS.queryId)?.dataset?.algoliaQueryId;
        let ajaxData = { ...elem.dataset };

        if (queryId && queryId !== "") {
          let authenticatedUserToken = document.querySelector(this.SELECTORS.authenticatedUserToken)?.dataset?.authenticatedUserToken;
          let userToken = document.querySelector("[data-user-token]")?.dataset?.userToken;
          let indexName = document.querySelector(this.SELECTORS.searchIndex)?.dataset?.searchIndex;

          ajaxData.queryId = queryId;
          ajaxData.authenticatedUserToken = authenticatedUserToken;
          ajaxData.userToken = userToken;
          ajaxData.indexName = indexName;
        }
        doAjax({
          url: elem.getAttribute("data-href"),
          data: ajaxData,
          dataType: "html",
          success: function (response) {
            if (response == 650) {
              let remoteHref = elem.getAttribute("data-exceeded-cart-qty");
              let productCode = elem.getAttribute("data-code");
              let baseCode = elem.getAttribute("data-base-code");
              if (!isNaN(productCode)) {
                remoteHref = remoteHref + productCode;
              } else if (!isNaN(baseCode)) {
                remoteHref = remoteHref + baseCode;
              } else {
                remoteHref =
                  remoteHref + elem.getAttribute("data-product-code");
              }
              doAjax({
                url: remoteHref,
                dataType: "html",
                success: function (html) {
                  elem.disabled = false;
                  ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                    unsafeContent: html,
                    modalClass: "exceeded-cart-products",
                  });
                  ctx.liveRegion.sayMessage(ctx.a11yMessages.cart.error);
                  console.info(
                    "[AddToCart] Exceed product max number on cart.",
                  );
                },
                error: function (xhr) {
                  elem.disabled = false;
                  console.error("[AddToCart]", xhr, arguments);
                  ctx.liveRegion.sayMessage(ctx.a11yMessages.cart.error);
                },
              });
            } else if (response == 651) {
              let remoteHref = elem.getAttribute("data-lowstock-cart-qty");
              let productCode = elem.getAttribute("data-code");
              let baseCode = elem.getAttribute("data-base-code");
              if (!isNaN(productCode)) {
                remoteHref = remoteHref + productCode;
              } else if (!isNaN(baseCode)) {
                remoteHref = remoteHref + baseCode;
              } else {
                remoteHref =
                  remoteHref + elem.getAttribute("data-product-code");
              }
              doAjax({
                url: remoteHref,
                dataType: "html",
                success: function (html) {
                  elem.disabled = false;
                  ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                    unsafeContent: html,
                    modalClass: "exceeded-cart-products",
                  });
                  ctx.liveRegion.sayMessage(ctx.a11yMessages.cart.error);
                  console.info("[AddToCart] Lowstock product number on cart.");
                },
                error: function (xhr) {
                  elem.disabled = false;
                  console.error("[AddToCart]", xhr, arguments);
                  ctx.liveRegion.sayMessage(ctx.a11yMessages.cart.error);
                },
              });
            } else {
              // success
              elem.disabled = false;
              let inWishlistLayer = payload.inWishlistLayer;
              ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtocart, {
                button: elem,
                inWishlistLayer: inWishlistLayer,
              });
              ctx.liveRegion.sayMessage(ctx.a11yMessages.cart.added);
            }
            // remove loading on add to cart button
            payload.button.classList.remove(ctx.CLASSES.addingClass);

            ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
              button: elem,
            });
          },
          error: function (xhr) {
            // ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {button: elem});
            let sizeErrorBox = document.querySelector(
              "[data-sizes-error=prod_" + elem.getAttribute("data-code") + "]",
            );
            // on error i check the status
            if (xhr.status == "510") {
              // url for availability
              var remoteHref =
                ctx.mainTarget.getAttribute("data-remote-unavailable") +
                $elem.getAttribute("data-code");
              // ajax call
              doAjax({
                url: remoteHref,
                dataType: "html",
                success: function (html) {
                  elem.disabled = false;
                  ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, html);
                },
                error: function (xhr) {
                  elem.disabled = false;
                  sizeErrorBox.innerHTML =
                    "Error in addtocart " + xhr.responseText;
                  console.error("[AddToCart]", xhr, arguments);
                },
              });
            } else {
              elem.disabled = false;
              ctx.liveRegion.sayMessage(ctx.a11yMessages.cart.error);
              sizeErrorBox.innerHTML = "Error in addtocart " + xhr.responseText;
              console.error("[AddToCart]", xhr, arguments);
            }
          },
        });
      },
    );

    // adding class
    this.$on(
      this.$customEvents.LOADER_EVENTS.showLocal,
      ({ event, payload }) => {
        payload.button.classList.add(ctx.CLASSES.addingClass);
        // show loader
      },
    );

    // on OPEN select
    $(".sizes-select").on("select2:open", () => {
      $(".select2-results__options").css("pointer-events", "none");
      // DISABLE SELECTION on open mobile
      setTimeout(() => {
        $(".select2-results__options").css("pointer-events", "auto");
      }, 500);
      if ($(".modelfitting", ".custom-dt-dropdown").length == 0) {
        if ($(".sizes-select").hasClass("model-fitting")) {
          const modelFitting = $(".sizes-select.model-fitting").data("fitting");
          $(".custom-dt-dropdown").append(
            `<div class="modelfitting">${modelFitting}</div>`,
          );
        }
      }

      if ($(".divider", ".custom-dt-dropdown").length == 0) {
        $(".custom-dt-dropdown").prepend("<span class='divider'></span>");
        if (isMobile(MobileBreakpoint.Max1023)) {
          $(".divider").after(
            "<div class='mobile-placeholder'>" +
              $(".sizes-select").data("placeholder") +
              "</div>",
          );
        }
      }
      if (isMobile(MobileBreakpoint.Max1023)) {
        $("body").css("overflow-y", "hidden");
        FixBody.block();
        $(".background-select-layer").show();
      }
    });

    $(".sizes-select-modal").on("select2:open", () => {
      $(".select2-results__options").css("pointer-events", "none");
      // DISABLE SELECTION on open mobile
      setTimeout(() => {
        $(".select2-results__options").css("pointer-events", "auto");
      }, 500);

    });

    // SELECT on CLOSE
    $(".sizes-select").on("select2:close", () => {
      $(".background-select-layer").hide();
      FixBody.unblock();
      $("body").css("overflow-y", "auto");
    });

    // added class
    this.$on(
      this.$customEvents.PRODUCT_EVENTS.addedtocart,
      ({ event, payload }) => {
        let ctx = this;
        payload.button.classList.remove(ctx.CLASSES.addingClass);
        payload.button.classList.add(ctx.CLASSES.addedClass);
        // and remove after 1,5 sec

        // hide cart
        setTimeout(function () {
          payload.button.classList.remove(
            ctx.CLASSES.addingClass,
            ctx.CLASSES.addedClass,
          );
        }, 1500);
      },
    );
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
  }
}
